// deps
import React, { memo, ReactElement } from "react";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

// styles
import { ToggleBarStyled, ToggleThumbStyled } from "./styles/ToggleSwitch.styled";

export interface ToggleSwitchProps {
    selected: boolean;
    className?: string;
    "data-testid"?: string;
    isDisabled?: boolean;
    onClick?: VoidFunction;
    activeColor?: keyof IColors;
    backgroundColor?: keyof IColors;
    thumbColor?: keyof IColors;
}

export const DATA_TEST_IDS = {
    CONTAINER: "toggle-switch-container",
    BAR: "toggle-switch-bar",
    THUMB: "toggle-switch-thumb",
};

function ToggleSwitch(props: ToggleSwitchProps): ReactElement {
    const {
        selected,
        className,
        "data-testid": dataTestId = DATA_TEST_IDS.CONTAINER,
        isDisabled = false,
        onClick,
        activeColor,
        backgroundColor,
        thumbColor,
    } = props;

    return (
        <div className={className} data-testid={dataTestId} onClick={onClick}>
            <ToggleBarStyled
                $isActive={selected}
                $isDisabled={isDisabled}
                $activeColor={activeColor}
                $backgroundColor={backgroundColor}
                data-testid={DATA_TEST_IDS.BAR}
            >
                <ToggleThumbStyled $isActive={selected} $thumbColor={thumbColor} data-testid={DATA_TEST_IDS.THUMB} />
            </ToggleBarStyled>
        </div>
    );
}

export default memo<ToggleSwitchProps>(ToggleSwitch);
